
import BlockAction from "./BlockAction/BlockAction";
import BlockJump from "./BlockJump/BlockJump";
import BlockScenario from "./BlockScenario/BlockScenario";
import BlockStatement from "./BlockStatement/BlockStatement";
import BlockTemplate from "./BlockTemplate/BlockTemplate";
import BlockAnnouncement from "./BlockAnnouncement/BlockAnnouncement";

import { memo } from "react";
import { isEmpty, xorWith, isEqual } from "lodash";

const isArrayEqual = (x, y) => {
    return JSON.stringify(x) == JSON.stringify(y)
    return isEmpty(xorWith(x, y, isEqual));
};

function isEqualBlock(prevBlock, nextBlock) {

    if (prevBlock.x != nextBlock.x || prevBlock.y != nextBlock.y) {
        return false;
    }

    if (prevBlock.name != nextBlock.name) {
        return false;
    }

    // Re-render block is lowVersion
    if ((prevBlock.lowVersion != nextBlock.lowVersion)) {
        return false;
    }

    // Those cases are here to re-redender block from form modification 
    if (prevBlock.children && nextBlock.children && isArrayEqual(prevBlock.children, nextBlock.children) == false) {
        return false;
    }

    if (nextBlock.type && nextBlock.type.name == 'propos' && isArrayEqual(prevBlock.data.messages, nextBlock.data.messages) == false) {
        return false;
    }

    if (nextBlock.type && nextBlock.type.name == 'propos' && isEqual(prevBlock.data.variable_redirect, nextBlock.data.variable_redirect) == false) {
        return false;
    }
    //console.log(prevBlock.type.name);
    return true;
}

// Helper to get block composent, use memo for no re-render
export default {
    action: memo(BlockAction, isEqualBlock),
    magic: memo(BlockJump, isEqualBlock),
    propos: memo(BlockStatement, isEqualBlock),
    scenario: memo(BlockScenario, isEqualBlock),
    template: memo(BlockTemplate, isEqualBlock),
    announcement: memo(BlockAnnouncement, isEqualBlock),
}